export enum CtaTypeEnum {
  BOOKING_CALENDAR = "booking_calendar",
  CUSTOM = "custom"
}
